import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { KYMW1201Model } from "../kymw1201.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from "../../../../shared/http/pless-http.service";
import { PlessDialogServiceSub } from "../../../../commons/kymw00/pless-dialog-service-sub";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { OrderNumQuota } from "../vo/order-num-quota.model";

// レスポンス構造
export type GetOrderNumQuotaListResponse = {
    OrderNumQuotaCode: string;
    OrderNumQuotaName: string;
    DelivCatalogID: string;
    DeliveryWeekFixFlag: string;
    OrderNumQuotaCodeName: string;
}[];

/**
 * 注文コード割当コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetOrderNumQuotaList
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderNumQuotaList extends PlessJsonResponderSub<GetOrderNumQuotaListResponse> {
  private model: KYMW1201Model;
  private calbak: () => void;
  private orderCode: string = null;
  private mediumType: string = null;
  private multiPublishFlg: string = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderNumQuotaList
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        MediumType: this.mediumType,
        MultiPublishFlg: this.multiPublishFlg,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1201Model} model
   * @param {string} orderCode
   * @param {string} mediumType
   * @param {string} multiPublishFlg
   * @memberof GetOrderNumQuotaList
   */
  execute(
    model: KYMW1201Model,
    orderCode: string,
    mediumType: string,
    multiPublishFlg: string,
    f: () => void = null
  ): void {
    this.model = model;
    this.orderCode = orderCode;
    this.mediumType = mediumType;
    this.multiPublishFlg = multiPublishFlg;
    this.calbak = f;
    this.send("KYMW02getOrderNumQuotaList", this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: GetOrderNumQuotaListResponse) {
    this.model.orderNumQuotaList = data.map((_) => {
      const label = _.OrderNumQuotaCode + ":" + _.OrderNumQuotaName;
      return new OrderNumQuota(
        _.OrderNumQuotaCode,
        _.OrderNumQuotaName,
        _.DelivCatalogID,
        _.DeliveryWeekFixFlag,
        _.OrderNumQuotaCodeName,
        label
      );
    });
    if (this.calbak) this.calbak();
  }
}
